import MandalaClanAppBackend from "mandala-clan-app-client";
import env from "react-dotenv";

export const MandalaClanAppBackendApi = new MandalaClanAppBackend({
  transport: {
      type: "https",
      host: env.API_HTTP ? env.API_HTTP : "prod.api.enterthemandala.app",
      port: 443
  },
});